<template>
    <a href="javascript:void(0)" class="p-4 relative text-black no-underline text-sm" @click="handleClick(name)" v-bind:class="{'font-bold active': active == name}">
        <slot />
    </a>
</template>

<script>
export default {
    props: {
        handleClick: Function,
        name: String,
        active: String
    }
}
</script>

<style lang="scss" scoped>
    .active {
        @apply .relative;

        &:after {
            @apply .block .w-full .bg-blue .absolute .pin-l .pin-r;

            content: '';

            height: 2px;
            bottom: -2px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/tabs/Trigger.vue